var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3385 1.55859H22.1264C19.6096 1.55859 17.5693 3.58474 17.5693 6.08411V64.9158C17.5693 67.4152 19.6096 69.4413 22.1264 69.4413H47.3385C49.8554 69.4413 51.8956 67.4152 51.8956 64.9158V6.08411C51.8956 3.58474 49.8554 1.55859 47.3385 1.55859Z",
    fill: "url(#paint0_linear_12309_240836)",
    stroke: "#6D6D6D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4988 1.55859C25.4988 1.55859 25.6469 3.80438 26.5298 3.80438H42.3657C43.243 3.80438 43.5392 1.55859 43.5392 1.55859H25.4988V1.55859Z",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9763 33.1467C38.9592 31.0932 40.6681 30.0976 40.7479 30.0523C39.7795 28.6494 38.2757 28.4571 37.7516 28.4458C36.4927 28.3157 35.268 29.1925 34.6243 29.1925C33.9806 29.1925 32.978 28.4571 31.9128 28.4797C30.54 28.5024 29.2583 29.2887 28.552 30.5162C27.0994 33.0109 28.1817 36.6822 29.5716 38.7017C30.2666 39.6917 31.0811 40.7948 32.1464 40.7552C33.1888 40.7099 33.5762 40.0933 34.8351 40.0933C36.094 40.0933 36.4471 40.7552 37.5294 40.7269C38.6459 40.7099 39.3523 39.7313 40.0244 38.7357C40.8276 37.6043 41.1523 36.4842 41.1637 36.4277C41.1352 36.4163 38.9934 35.6074 38.9706 33.1467H38.9763Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9256 27.1163C37.4838 26.4205 37.8712 25.4758 37.7629 24.5142C36.954 24.5481 35.9401 25.0685 35.3534 25.753C34.835 26.3526 34.3736 27.3369 34.4932 28.259C35.4046 28.3269 36.3388 27.8008 36.9256 27.1163V27.1163Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12309_240836",
    x1: 16.4756,
    y1: 4.09854,
    x2: 52.6098,
    y2: 67.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone);
export default __webpack_public_path__ + "static/media/i-phone.aea953ec056fd832f0327326b8635459.svg";
export { ForwardRef as ReactComponent };